import { useCallback } from "react"
import { IVendedor } from "../../application/models/IVendedor"
import { delay } from "../../utils/delay"
import { useAxiosInstances } from "../axios-instance"

export const useVendedorApi = () => {
  // Trazer lista de vendedores

  const { axiosAuthInstance } = useAxiosInstances()



  const getVendedorByIdApi = useCallback(async (id: string): Promise<IVendedor> => {
    await delay(1551)

    const vendedor:IVendedor[] = []
    return vendedor[0]
  }, [])

  const createVendedorApi = useCallback(async (data: {
    nome: string,
    email: string
  }): Promise<IVendedor> => {
    await delay(1551)
    const vendedor:IVendedor[] = []
    return vendedor[0]
  }, [])

  const editVendedorApi = useCallback(async (data: {
    id: string,
    nome: string,
    email: string,
    status: boolean
  }): Promise<IVendedor> => {
    await delay(1551)

    const vendedor :IVendedor[] = []

    return vendedor[0]
  }, [])

  const getVendedoresByAtivoApi = useCallback(async (IdUsuario: number, IdCliente: number): Promise<IVendedor[]> => {
    try {
      const result = await axiosAuthInstance.get(`/vendedor`, {
        params: { IdUsuario, IdCliente },
        validateStatus: (status) => status === 200 || status === 404 || status === 500
      });

      if (result.status === 404 || result.status === 500) {
        return [];
      }

      return result.data.vendedor || [];
    } catch (error: any) {
      return [];
    }
  }, [axiosAuthInstance]);

  return {
    
    getVendedorByIdApi,
    createVendedorApi,
    editVendedorApi,
    getVendedoresByAtivoApi
  }
}